<template>
  <div class="historySelect">
    <section class="historySelect_btns">
      <v-btn text color="primary" @click="toggleBtn('range')">
        <div class="historySelect_text">絞りこみ</div>
        <span
          class="icon icon-chevron-down"
          :class="{
            'historySelect_chevron-open': open && selectedGroup == 'range',
          }"
        />
      </v-btn>
      <v-btn v-if="isImage" text color="primary" @click="toggleBtn('image')">
        <div class="historySelect_text">カメラ映像</div>
        <span
          class="icon icon-chevron-down"
          :class="{
            'historySelect_chevron-open': open && selectedGroup == 'image',
          }"
        />
      </v-btn>
    </section>
    <div v-if="open && selectedGroup == 'range'" class="historySelect_list">
      <div class="historySelect_cat historySelect_cat-daterange">
        <v-checkbox
          v-model="hasDate"
          :disabled="loadingHistory"
          @change="handleCheckDates"
        />
        <DateRangePicker
          :dates="dates"
          :active="hasDate"
          @applySetDates="applySetDates($event)"
        />
      </div>
    </div>
    <div v-if="open && selectedGroup == 'date'" class="historySelect_list">
      <div class="historySelect_cat historySelect_cat-daterange">
        <v-checkbox v-model="hasDay" @change="handleCheckDay" />
        <day-picker
          :min-date="minDate"
          :max-date="maxDate"
          :day.sync="selectedDay"
          :active="hasDay"
        />
        <div class="historySelect_updown">
          <span
            v-ripple
            :class="{
              'historySelect_updown-active': hasDay && !dateDownDisabled,
            }"
            class="icon icon-chevron-down"
            @click="handleDayDown"
          ></span>
          <v-divider vertical />
          <span
            v-ripple
            :class="{
              'historySelect_updown-active': hasDay && !dateUpDisabled,
            }"
            class="icon icon-chevron-down rotate-up"
            @click="handleDayUp"
          ></span>
        </div>
      </div>
    </div>
    <div v-if="open && selectedGroup == 'image'" class="historySelect_list">
      <v-btn
        depressed
        x-small
        text
        outlined
        class="rowSelect_list-btn"
        :class="{
          'rowSelect_list-btn-selected': selectedImage == 0,
        }"
        @click="onSelect(0)"
      >
        カメラ映像 非表示
      </v-btn>
      <v-btn
        depressed
        x-small
        text
        outlined
        class="rowSelect_list-btn"
        :class="{
          'rowSelect_list-btn-selected': selectedImage == 1,
        }"
        @click="onSelect(1)"
      >
        カメラ映像 表示
      </v-btn>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/inputs/DateRangePicker.vue';
import DayPicker from '@/components/inputs/DayPicker.vue';
import {
  areDatesSameDay,
  getDownloadTimePeriod,
  subtractDays,
} from '@/utils/date';
import dayjs from 'dayjs';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'HistorySelect',
  components: { DateRangePicker, DayPicker },
  props: {
    isImage: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: () => subtractDays(new Date(), 7),
    },
    maxDate: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      open: false,
      selectedImage: 1,
      textValue: {},
      selectedGroup: '',
      hasDay: false,
      hasDate: false,
      dates: getDownloadTimePeriod(),
      selectedDay: new Date(),
    };
  },
  computed: {
    ...mapState({
      historyDates: (state) => state.log.historyDates,
      historyDatesChecked: (state) => state.log.historyDatesChecked,
      historySelectedGroup: (state) => state.log.historySelectedGroup,
      loadingHistory: (state) => state.log.loadingHistory,
    }),
    dateUpDisabled() {
      return areDatesSameDay(this.selectedDay, this.minDate);
    },
    dateDownDisabled() {
      return areDatesSameDay(this.selectedDay, this.maxDate);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('log', [
      'setHistoryDates',
      'setHistoryDatesChecked',
      'setHistorySelectedGroup',
    ]),
    init() {
      if (this.historyDates.length) {
        this.dates = this.historyDates;
      }
      if (this.historyDatesChecked) {
        this.hasDate = this.historyDatesChecked;
      }
      if (this.historySelectedGroup === 'image' && !this.isImage) {
        this.open = false;
        this.setHistorySelectedGroup('');
      } else {
        this.open = !!this.historySelectedGroup;
        this.selectedGroup = this.historySelectedGroup;
      }
    },
    handleDayUp() {
      this.selectedDay = dayjs(this.selectedDay).subtract(1, 'day').toDate();
    },
    handleDayDown() {
      this.selectedDay = dayjs(this.selectedDay).add(1, 'day').toDate();
    },
    toggleBtn(groupIndex) {
      if (this.open && this.selectedGroup === groupIndex) {
        this.open = false;
        this.setHistorySelectedGroup('');
      } else {
        this.open = true;
        this.setHistorySelectedGroup(groupIndex);
      }
      this.selectedGroup = groupIndex;
    },
    onSelect(index) {
      this.selectedImage = index;
      this.$emit('image', !!index);
    },
    handleCheckDay() {
      this.$emit('day', this.hasDay ? this.selectedDay : null);
    },
    handleCheckDates(val) {
      this.setHistoryDatesChecked(val);
      this.setHistoryDates(this.hasDate ? this.dates : []);
      this.$emit('dates', this.hasDate ? this.dates : []);
    },
    applySetDates(event = []) {
      if (event.length) {
        this.dates = event;
        this.hasDate = true;
        this.handleCheckDates(true);
      } else {
        this.dates = this.historyDates.length
          ? this.historyDates
          : getDownloadTimePeriod();
      }
    },
  },
};
</script>

<style lang="scss">
.historySelect {
  width: 100%;
  &_btns {
    display: flex;
    justify-content: flex-end;
  }
  &_updown {
    width: 120px;
    height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    padding: 0 23px;
    border-radius: 5px;
    border: solid 1px #ccc;
    background-color: #fff;
    pointer-events: none;
    &-active {
      pointer-events: all;
      color: var(--v-primary-base) !important;
      cursor: pointer;
    }
    .rotate-up {
      display: inline-block;
      transform: rotate(180deg);
    }
    .icon-chevron-down {
      color: #ccc;
    }
  }
  &_cat {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    & .dateRangePicker_dates {
      margin-top: 0;
      width: unset;
      flex-wrap: nowrap;
      & .dateRangePicker_separator {
        margin-right: 10px;
      }
    }
    &-daterange {
      flex-wrap: nowrap;
      .v-input--checkbox {
        margin-top: 0;
        padding-top: 0;
        .v-messages {
          display: none;
        }
        .v-input__slot {
          margin-bottom: 0;
        }
      }
    }
  }
  &_chevron {
    &-open {
      transform: rotate(180deg);
    }
  }
  &_list {
    margin-top: 5px;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    &-btn {
      margin: 0;
      padding: 0;
      color: #989898 !important;
      margin-right: 5px;
      font-size: 12px !important;
      line-height: 1.08 !important;
      border: solid 1px #989898;
      border-color: #989898;
      font-family: 'Noto Sans JP', sans-serif;
      &-selected {
        color: #0075c2 !important;
        background-color: #dbe2f3;
        border: none;
      }
    }
  }
}
</style>
